import { useState, useEffect } from "react";
import { client } from "../sanity/client";

function About() {
  const [aboutText, setAboutText] = useState("");

  useEffect(() => {
    client.fetch('*[_type == "about"]').then((data) => {
      setAboutText(data[0].description);
    });
  }, []);
  return (
    <>
      <p>
        <span className="prompt">ziad@portfolio:</span>
        <span className="path">~</span>
        <span className="command">$ cd about && about.txt</span>
      </p>

      <div className="section">
        <div className="slide-right">
          <p>{aboutText}</p>
        </div>
      </div>
    </>
  );
}
export default About;
